/**
 * Tunable parameters for the «Как в бункере» filter. Defaults are tuned for
 * speech on a typical condenser/headset mic: aggressive enough to kill room
 * tone and keyboard clatter, gentle enough to keep natural voice dynamics.
 *
 * All thresholds are dBFS. The single user-facing toggle uses these
 * defaults; sliders (gate / clarity / level) can later override individual
 * fields without touching the integration.
 */
export interface BunkerFilterParams {
  /** High-pass cutoff (Hz). Removes rumble / mic-stand thump. */
  highpassHz: number;
  /** Envelope attack / release (ms) — how fast the level follower reacts. */
  envAttackMs: number;
  envReleaseMs: number;

  /** Noise gate / expander. */
  gateThresholdDb: number;
  gateRatio: number;
  /** Deepest attenuation the gate may apply (dB, negative). */
  gateRangeDb: number;
  /** Gain-change smoothing (ms) to avoid zipper noise on gate open/close. */
  gateAttackMs: number;
  gateReleaseMs: number;

  /** Compressor — evens out level so makeup gain can lift without clipping. */
  compThresholdDb: number;
  compRatio: number;
  /** Makeup / normalisation gain applied after compression (dB). */
  makeupDb: number;

  /** Output limiter ceiling (dBFS, negative). */
  ceilingDb: number;
}

export const DEFAULT_PARAMS: BunkerFilterParams = {
  highpassHz: 85,
  envAttackMs: 2,
  envReleaseMs: 60,

  gateThresholdDb: -48,
  gateRatio: 4,
  gateRangeDb: -45,
  gateAttackMs: 3,
  gateReleaseMs: 120,

  compThresholdDb: -24,
  compRatio: 3,
  makeupDb: 6,

  ceilingDb: -1,
};

/** Message sent from the main thread to the worklet to update params. */
export interface BunkerParamMessage {
  type: 'params';
  params: Partial<BunkerFilterParams>;
}
